import { PaletteColor } from "../types/PaletteColor.ts";

// 対応表を定義
const colorMapping: Record<string, PaletteColor> = {
  green: "Green",
  teal: "Green",
  lightgreen: "Lightgreen",
  lime: "Lightgreen",
  cyan: "Skyblue",
  lightblue: "Skyblue",
  blue: "Blue",
  indigo: "Purple",
  deeppurple: "Purple",
  purple: "Lavender",
  pink: "Red",
  red: "Red",
  deeporange: "Orange",
  orange: "Orange",
  amber: "Orange",
  yellow: "Orange",
  grey: "Gray",
  bluegrey: "Gray",
  brown: "Gray",
};

// URLのcolorパラメータからMyPaletteColorを取得
export const getMyPaletteColor = (color: string | null): PaletteColor => {
  if (!color) return "Blue"; // デフォルトはBlue
  const normalizedColor = color.toLowerCase();
  return colorMapping[normalizedColor] || "Blue"; // 対応表にない場合もBlue
};
